<template>
  <div class="main-lecturaCajasPicking">
    <f7-popup
      class="popupLecturaDeCajasPicking hide-popup-scanner"
      :close-by-backdrop-click="true"
      :opened="popupLecturaDeCajas"
      @popup:closed="popupLecturaDeCajas = false"
    >
      <f7-page>
        <f7-navbar
          :title="$t('commercialization.common.boxesReading')"
          sliding
          :style="appTheme"
        >
          <f7-nav-right>
            <f7-link @click="ClosePopUpLecturaCajas">
              <img :src="icClose">
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <!-- Cabecera Formulario -->
        <!-- TODO: QUITAR LOS DATOS ESTÁTICOS -->
        <div class="content-information">
          <div class="content-information__data">
            <div class="content-information__data-span">
              <span class="title">
                {{ $t('common.logisticsUnit') }}
              </span>
              <span class="data"> {{ articuloNumeroSerie.NumeroSerie }} </span>
            </div>
            <div class="content-information__data-span">
              <span class="title">
                {{ $t('common.product') }}
              </span>
              <span class="data"> {{ articuloNumeroSerie.InfoProducto?.Nombre ?? '' }} </span>
            </div>
            <div class="content-information__data-span">
              <span class="title">
                {{ $t('common.package') }}
              </span>
              <span class="data"> {{ articuloNumeroSerie.InfoEnvase?.Nombre ?? '' }} </span>
            </div>
          </div>

          <div class="content-information__boxes">
            <span> {{ `${numChecked} ${$t('common.of')} ${articuloNumeroSerie.ArticulosElaborados?.length ?? 0}` }} </span>
            <img
              src="@/static/icons/ic_batch_blue.svg"
              width="30px"
            >
          </div>
        </div>
        <div class="content-palet-data">
          <f7-list
            v-if="articuloNumeroSerie.ArticulosElaborados && articuloNumeroSerie.ArticulosElaborados.length > 0"
            class="content-palet-data__list"
          >
            <f7-checkbox
              :checked="checkAll"
              class="padding-left"
              @change="checkAll = !checkAll; ChangeCheckedAll($event.target.checked)"
            >
              <span>
                {{ $t('common.selectAll') }}
              </span>
            </f7-checkbox>
            <f7-list-item
              v-for="(articuloElaborado, i) in articuloNumeroSerie.ArticulosElaborados"
              :key="i"
              checkbox
              class="content-palet-data__list-item"
              :title="articuloElaborado.CodigoBarras"
              :checked="articuloElaborado.checked || checkAll"
              @change="ChangeCheckedElaboratedItem(articuloElaborado, $event.target.checked)"
            />
          </f7-list>
        </div>

        <UCCodeScanner
          :text-button="$t('commercialization.picking.palletizing.boxesRead.labels.scanBox')"
          :allow-manual-code-entry="configuracionLecturaCajasFrmPicking.LecturaContinuaCodigosBarrasManual"
          :continuous-bar-code-reading="configuracionLecturaCajasFrmPicking.LecturaContinuaCodigosBarras || configuracionLecturaCajasFrmPicking.LecturaContinuaCodigosBarrasManual"
          :autofocus-on-input="configuracionLecturaCajasFrmPicking.LecturaContinuaCodigosBarrasManual"
          :auto-open-camera="!configuracionLecturaCajasFrmPicking.LecturaContinuaCodigosBarrasManual"
          @code-reading="BarCodeReadingEvent"
          @codigo-barras="BarCodeReadingEvent"
        />
      </f7-page>
    </f7-popup>
  </div>
</template>

<script>
import { useSettingRef } from '@erpagroapp/settings';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import icClose from '@/static/icons/ic_close.svg';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';

export default {
  name: 'PCLecturaCajasPicking',
  components: {
    UCCodeScanner,
  },

  emits: ['closePopupClick'],

  data() {
    return {
      popupLecturaDeCajas: false,
      articuloNumeroSerie: {},
      icClose,
      checkAll: false,
      numChecked: 0,
      configuracionLecturaCajasFrmPicking: {
        LecturaContinuaCodigosBarras: useSettingRef('Picking.LecturaCajas.LecturaContinuaCodigosBarras'),
        LecturaContinuaCodigosBarrasManual: useSettingRef('Picking.LecturaCajas.LecturaContinuaCodigosBarrasManual'),
      },
    };
  },
  computed: {
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-plum-shadow)',
        '--f7-navbar-text-color': '#fff',
      };
    },
  },

  methods: {
    /**
     * @public
     * @returns {void}
     */
    OpenPopup(artNS) {
      Log(this, this.OpenPopup.name);
      this.popupLecturaDeCajas = true;
      this.articuloNumeroSerie = artNS;
      this.ChangeChecked();
    },
    ChangeCheckedAll(value) {
      Log(this, this.ChangeCheckedAll.name);
      this.articuloNumeroSerie.ArticulosElaborados.forEach((b) => {
        b.checked = value;
      });
      this.RecuentoDeCajas();
    },

    ChangeCheckedElaboratedItem(caja, value) {
      Log(this, this.ChangeCheckedElaboratedItem.name);
      caja.checked = value;
      this.ChangeChecked();
    },

    ChangeChecked() {
      Log(this, this.ChangeChecked.name);

      let esDiferente = false;
      const checkArticuloElaborado = this.articuloNumeroSerie.ArticulosElaborados[0].checked;

      this.articuloNumeroSerie.ArticulosElaborados.forEach((ae) => {
        if (ae.checked !== checkArticuloElaborado) {
          esDiferente = true;
        }
      });

      if (!esDiferente) {
        this.checkAll = checkArticuloElaborado;
      } else {
        this.checkAll = false;
      }
      this.RecuentoDeCajas();
    },

    RecuentoDeCajas() {
      Log(this, this.RecuentoDeCajas.name);
      this.numChecked = this.articuloNumeroSerie.ArticulosElaborados.filter((f) => f.checked).length;
    },

    ClosePopUpLecturaCajas() {
      Log(this, this.ClosePopUpLecturaCajas.name);
      this.$emit('closePopupClick', this.articuloNumeroSerie);
      this.popupLecturaDeCajas = false;
    },

    // *********************************************************************************************** \\
    // **************************************** CONEXIONES ******************************************* \\
    // *********************************************************************************************** \\

    async BarCodeReadingEvent(code) {
      Log(this, this.BarCodeReadingEvent.name);
      HiDialog.Preloader(true, this.$t('codeScanner.info.validatingBarcode'));
      this.Conexion_ObtenerArticuloElaborado(code).then((result) => {
        result.checked = true;
        const caja = this.articuloNumeroSerie.ArticulosElaborados.find((f) => f.Id === result.Id);
        if (caja) {
          caja.checked = true;
          this.ChangeChecked();
        } else {
          HiNotification.Toast(this.$t('commercialization.picking.palletizing.boxesRead.readCode.elaboratedArticleNotFound'));
        }
      }).catch((result) => {
        HiNotification.Toast(result);
      });
      HiDialog.Preloader(false);
    },

    Conexion_ObtenerArticuloElaborado(codigoBarrasArticuloElaborado) {
      Log(this, this.Conexion_ObtenerArticuloElaborado.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerArticuloElaboradoXCodigo(
          codigoBarrasArticuloElaborado,
        ).then((result) => {
          if (result.Valor) {
            resolve(JSON.parse(result.Mensaje));
          } else {
            reject(result.Mensaje);
          }
        })
          .catch((error) => {
            reject(error);
            LogError(this, this.BarCodeReadingEvent.name, error);
          });
      });
    },
  },
};
</script>

<style lang="scss">
.popupLecturaDeCajasPicking {
  .content-information {
    display: grid;
    grid-template-columns: 3fr 1fr;
    padding: 10px;
    font-size: 17px;
    color: var(--his-steel-blue);
    background: var(--his-disabled);

    &__data {
      padding-left: 10px;

      &-span {
        display: grid;
        grid-auto-flow: column;
        grid-template-columns: 1fr 2fr;
        grid-column-gap: 8px;
        padding-right: 10px;

        .title {
          font-weight: 600;
        }

        .data {
          -webkit-line-clamp: 1;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          overflow-x: hidden;
        }
      }
    }

    &__boxes {
      font-size: 20px;
      font-weight: 600;
      align-items: center;
      justify-content: center;
      display: flex;

      span {
        padding-right: 5px;
      }
    }
  }

  .content-palet-data {
    height: calc(100% - 150px);
    overflow-x: scroll;

    &__list {
      .checkbox {
        display: flex;
        line-height: normal;
        align-items: center;
        height: 40px;

        span {
          padding-left: 20px;
          font-size: 16px;
        }
      }

      &-item {
        .item-title {
          color: var(--his-slate-blue);
          font-size: 20px;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
